// Components/Header/Header.jsx
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n.ts";
import { HeaderContainer } from "./Header.style";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";
import logoBlack from "../../Assets/LogoBlack.svg";
import logoWhite from "../../Assets/LogoWhite.svg";

const menuItems = [
  { path: "/Biografia", key: "nav.biografia" },
  { path: "/Autor", key: "nav.autor" },
  { path: "/Cursos", key: "nav.cursos" },
  { path: "/Blog", key: "nav.blog" },
  { path: "/Conteudo", key: "nav.conteudo" },
  { path: "/Eventos", key: "nav.eventos" },
  { path: "/Contato", key: "nav.contato" },
];

export default function Header() {
  const { t } = useTranslation();
  const [menuIsVisible, setMenuIsVisible] = useState(false);
  const [animation, setAnimation] = useState(false);
  const path = useLocation().pathname;

  useEffect(() => {
    const onScroll = () => setAnimation(window.scrollY > 100);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleMenuClose = () => setMenuIsVisible(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);

  useEffect(() => {
    const shouldScroll = localStorage.getItem("scrollToContact");
    if (shouldScroll === "true") {
      localStorage.removeItem("scrollToContact");
      const scrollToContact = () => {
        const el = document.getElementById("contact");
        if (el) el.scrollIntoView({ behavior: "smooth" });
        else setTimeout(scrollToContact, 100);
      };
      scrollToContact();
    }
  }, []);

  const changeLang = (lng) => i18n.changeLanguage(lng);

  const currentLng = (i18n.resolvedLanguage || i18n.language || "pt-BR")
    .toLowerCase()
    .startsWith("pt")
    ? "pt-BR"
    : i18n.resolvedLanguage || i18n.language;

  const isActiveLang = (lng) => currentLng === lng;

  return (
    <HeaderContainer isVisible={menuIsVisible} isanimation={animation}>
      <nav className="header">
        <div className="content">
          <Link to="/">
            <div className="logoSide">
              <img
                className={`logo logoBlack ${
                  menuIsVisible ? "hidden" : "visible"
                }`}
                src={logoBlack}
                alt="logotipo preto"
              />
              <img
                className={`logo logoWhite ${
                  menuIsVisible ? "visible" : "hidden"
                }`}
                src={logoWhite}
                alt="logotipo branco"
              />
            </div>
          </Link>

          <AiOutlineMenu
            onClick={() => setMenuIsVisible(true)}
            className="menu"
          />
          <AiOutlineClose
            onClick={handleMenuClose}
            className={`menu closeMenu ${menuIsVisible ? "visible" : ""}`}
          />

          <ul className="menuSide">
            <div className="language-mobile">
              <div className="containerList">
                <div className="list">
                  <button
                    aria-label="Mudar para Português (Brasil)"
                    aria-pressed={isActiveLang("pt-BR")}
                    className={isActiveLang("pt-BR") ? "selectLanguage" : ""}
                    onClick={() => changeLang("pt-BR")}
                  >
                    PT
                  </button>
                </div>
                <div className="list">
                  <p>|</p>
                </div>
                <div className="list">
                  <button
                    aria-label="Switch to English"
                    aria-pressed={isActiveLang("en")}
                    className={isActiveLang("en") ? "selectLanguage" : ""}
                    onClick={() => changeLang("en")}
                  >
                    EN
                  </button>
                </div>
                <div className="list">
                  <p>|</p>
                </div>
                <div className="list">
                  <button
                    aria-label="Cambiar a Español"
                    aria-pressed={isActiveLang("es")}
                    className={isActiveLang("es") ? "selectLanguage" : ""}
                    onClick={() => changeLang("es")}
                  >
                    ES
                  </button>
                </div>
              </div>
            </div>

            {menuItems.map((item) => {
              const isActive = path === item.path;
              return (
                <li
                  key={item.key}
                  className={`Options ${isActive ? "active" : ""}`}
                >
                  {item.path.startsWith("#") ? (
                    <a
                      href={item.path}
                      onClick={(e) => {
                        e.preventDefault();
                        const id = item.path.slice(1);
                        const el = document.getElementById(id);
                        if (path === "/") {
                          if (el) el.scrollIntoView({ behavior: "smooth" });
                        } else {
                          window.localStorage.setItem(
                            "scrollToContact",
                            "true"
                          );
                          window.location.href = "/";
                        }
                        setMenuIsVisible(false);
                      }}
                    >
                      {t(item.key)}
                    </a>
                  ) : (
                    <Link
                      to={item.path}
                      onClick={handleMenuClose}
                      className={isActive ? "active" : ""}
                    >
                      {t(item.key)}
                    </Link>
                  )}
                </li>
              );
            })}

            <div className="language-desktop">
              <div className="containerList">
                <div className="list">
                  <button
                    aria-label="Mudar para Português (Brasil)"
                    aria-pressed={isActiveLang("pt-BR")}
                    className={isActiveLang("pt-BR") ? "selectLanguage" : ""}
                    onClick={() => changeLang("pt-BR")}
                  >
                    PT
                  </button>
                </div>
                <div className="list">
                  <p>|</p>
                </div>
                <div className="list">
                  <button
                    aria-label="Switch to English"
                    aria-pressed={isActiveLang("en")}
                    className={isActiveLang("en") ? "selectLanguage" : ""}
                    onClick={() => changeLang("en")}
                  >
                    EN
                  </button>
                </div>
                <div className="list">
                  <p>|</p>
                </div>
                <div className="list">
                  <button
                    aria-label="Cambiar a Español"
                    aria-pressed={isActiveLang("es")}
                    className={isActiveLang("es") ? "selectLanguage" : ""}
                    onClick={() => changeLang("es")}
                  >
                    ES
                  </button>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </nav>
    </HeaderContainer>
  );
}
